var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewMessage = function SvgNewMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-382.000000, -120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)",
    fill: "#151B22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-/-New",
    transform: "translate(360.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007846,9.44008622 L16,16.000299 L12.7775176,12.8077988 L4.00936768,12.8077988 C3.7845422,12.8077988 3.59094539,12.7264222 3.42857143,12.5636665 C3.26619747,12.4009107 3.18501171,12.2193782 3.18501171,12.0190635 L3.18501171,11.204037 L14.4018735,11.204037 L14.401,9.6 L14.6491793,9.59646827 C15.1106139,9.58235056 15.5622148,9.52915747 16.0007846,9.44008622 Z M6.4,1.6002452 L1.6,1.6002452 L1.6,8.00026912 L9.60029734,8.00107835 C10.4588285,8.64588635 11.4513072,9.12199125 12.5285181,9.38017759 L12.5470726,9.3636545 C12.3846986,9.51389056 12.2035919,9.58900746 12.0037471,9.58900746 L3.18501171,9.58900746 L7.28306304e-14,12.8190665 L7.28306304e-14,0.788974564 C7.28306304e-14,0.563620482 0.0811857611,0.375828231 0.243559719,0.225592176 C0.405933677,0.0753561219 0.587040375,0.00023922143 0.786885246,0.00023922143 L6.56010189,-0.000119899227 C6.45511393,0.51696926 6.4,1.05217093 6.4,1.6002452 Z",
    id: "Color",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u25A0-Shape",
    fill: "#EA6B75",
    cx: 14,
    cy: 2,
    r: 6
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-message.cdf2d320.svg";
export { ForwardRef as ReactComponent };